export const getMemberProfileFromSpeakerProfile = (obj) => {
    return {
        id: obj.personId,
        memberId: '00000000-0000-0000-0000-000000000000',
        name: `${obj.firstName} ${obj.familyName}`,
        firstName: obj.firstName,
        dateOfBirth: null,
        primaryChapter: null,
        primaryChapterId: null,
        lastName: obj.familyName,
        webLoginIdhistorical: null,
        email: obj.email,
        username: null,
        percentageProfileComplete: null,
        middleName: null,
        preferredName: obj.preferredName,
        biography: obj.biography,
        type: null,
        gender: obj.gender,
        relationshipStatus: null,
        birthdate: null,
        phone: obj.phone,
        salesforceAccessfromExchange: null,
        cventAccessfromExchange: null,
        suffix: null,
        displayName: null,
        portalUserName: null,
        recordTypeName: null,
        portalAccessLevel: null,
        salutation: null,
        cookiesPolicyAccepted: obj.cookiesPolicyAccepted,
        termsAndConditionsAccepted: obj.termsAndConditionsAccepted,
        termsAndConditionsAcceptedDate: obj.termsAndConditionsAcceptedDate,
        cookiesPolicyAcceptedDate: obj.cookiesPolicyAcceptedDate,
        profileImageUrl: obj.profileImageUrl,
        fallbackProfileImageUrl: obj.fallbackProfileImageUrl,
    };
};
